<template>
	<b-modal
		id="publicationModal"
		modal-class="my-modal"
		:visible="true"
		@hidden="onHidden"

		size="xl"
		hide-header
		hide-footer
		centered
	>
		<b-button class="modal-close btn-white" @click="onClose">
			<span class="fe fe-x"></span>
			<span class="sr-only">Close</span>
		</b-button>
		<Publication v-bind="publication" class="modal-inner" />
	</b-modal>
</template>

<script>
import { mapState } from 'vuex'
import Publication from '@/components/Publication.vue'

export default {
	name: 'publication',
	components: {
		Publication
	},
	computed: mapState([ 'publication' ]),
	beforeCreate () {
		this.$store.dispatch( 'fetchPublication', this.$route.params );
	},
	destroyed () {
		this.$store.dispatch( 'clearPublication' )
	},
	methods: {
		onHidden () {
			this.$router.back()
		},
		onClose () {
			this.$root.$emit('bv::hide::modal', 'publicationModal' );
		},
		// onShown () {
		// 	this.$store.commit( 'toggleBlockBodyScroll', true )
		// },
		// onHide () {
		// 	this.$store.commit( 'toggleBlockBodyScroll', false )
		// }
	},
	beforeRouteLeave(to, from, next) {
		if ( to.name !== 'search' ) next({ name: 'search' })
		else next()
	}
}
</script>

<style lang="scss" scoped>
@import '../theme/scss/_user-variables.scss';

$color-text: black;
$color-secondary: #6E84A3;

.modal {

	/deep/ &-dialog {

		@media (min-width: 576px) and (max-width: 767px) {
			max-width: 90vw;
		}

		@media (min-width: 768px) and (max-width: 1023px) {
			max-width: 80vw;
		}
	}

	/deep/ &-body {
		padding: 1rem;
		min-height: calc(100vh - 1rem); // .modal-dialog-centered
		display: flex;
    flex-direction: column;

		@media (min-width: 576px) {
			padding: 1rem 2rem;
			min-height: calc(100vh - 3.5rem); // .modal-dialog-centered
		}

		@media (min-width: 768px) {
			padding: 3rem 4rem;
		}
	}

	&-close {
		border: none;
		padding: .5rem;
		color: $color-secondary;
		background-color: transparent;
		transition: color .2s ease-out;
		text-align: right;

		&:hover {
			color: $color-text;
		}

		@media (min-width: 768px) {
			position: absolute;
			padding: 1.5rem;
			top: 0;
			right: 0;
		}

		@media (min-width: 1024px) {
			padding: 1.5rem;
		}

		.fe {
			font-size: 2rem;
		}
	}

	&-inner {
		flex-grow: 1;
	}
}
</style>
